// Analytics preference (opt-out model) applied to the existing GA4 Consent Mode
// v2 setup. No popup/banner — the choice is made on the Privacy page and simply
// reapplied on load. Analytics is allowed unless the user has explicitly opted
// out (stored as "denied").
const KEY = "rr_analytics_consent";

export function analyticsAllowed() {
  try {
    return localStorage.getItem(KEY) !== "denied";
  } catch {
    return true;
  }
}

function applyConsent(value) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("consent", "update", { analytics_storage: value });
  }
}

export function setAnalyticsAllowed(allowed) {
  const value = allowed ? "granted" : "denied";
  try {
    localStorage.setItem(KEY, value);
  } catch {
    /* ignore */
  }
  applyConsent(value);
}

// Reapply the stored choice to Consent Mode on app load (no UI).
export function applyStoredConsent() {
  applyConsent(analyticsAllowed() ? "granted" : "denied");
}
